<p class="data-message">{{ data }}</p>

<od-icon-button
  (click)="snackBarRef.dismiss()"
  name="od-close-24"
  class="close-icon"
/>
